import { useMemo, useState } from "react";
import type { Status } from "types/Status";

interface UseStatusProps {
  initialStatus?: Status;
}

function useStatus(props?: UseStatusProps) {
  const { initialStatus = "fetching" } = props || {};
  const [status, setStatus] = useState<Status>(initialStatus);
  return useMemo(() => ({ status, setStatus }), [status, setStatus]);
}

export default useStatus;
